import styled, { css } from 'styled-components';

// ------------------- CrossSellProducts styles ------------------ //

export type CrossSellOrientation = 'horizontal' | 'vertical';

interface ContainerProps {
  crossSellTopFlag?: boolean;
  orientation?: CrossSellOrientation;
}

export const Container = styled.section<ContainerProps>`
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  padding-top: ${({ orientation }) =>
    orientation === 'vertical' ? '1.125rem' : '1.5rem'};
  min-width: ${({ orientation }) =>
    orientation === 'vertical' ? '18.375rem' : 'auto'};
  height: ${({ orientation }) =>
    orientation === 'vertical' ? '100%' : 'auto'};
  gap: ${({ orientation }) =>
    orientation === 'vertical' ? '0.625rem' : '1.5rem'};
  background: ${({ theme }) => theme.colors.white};
  padding-bottom: ${({ crossSellTopFlag, orientation }) =>
    orientation === 'vertical'
      ? '7.5rem'
      : crossSellTopFlag
      ? '1rem'
      : '6.75rem'};
`;

interface ProductsContainerProps {
  orientation?: CrossSellOrientation;
}

export const ProductsContainer = styled.div<ProductsContainerProps>`
  display: grid;
  grid-template-columns: ${({ orientation }) =>
    orientation === 'vertical'
      ? '1fr'
      : 'repeat(auto-fill, minmax(272px, 1fr))'};
  gap: 1.5rem;
  width: 100%;
`;

// ------------------- CrossSellItem styles ------------------ //

export const CardContainer = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.lightGray4};

  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  overflow: hidden;

  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  padding: 1rem 1rem 0.5rem 1rem;

  .cross_sell_conflict_left_button {
    width: 60%;
  }
`;

export const PriceAgreementContainer = styled.div`
  .hefesto-tag .hefesto-tag--success {
    font-size: 0.88rem;
  }
`;

export const CodeInfo = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.grayDark4};
`;

export const ProductInfo = styled.div`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.grayDark3};
  font-weight: 600;
  font-family: 'Source Sans Pro';
`;

export const ProductPrice = styled.div`
  font-family: 'Source Sans Pro';
  font-size: 2rem;
  line-height: 2.5rem;
  color: ${({ theme }) => theme.colors.grayDark3};
  font-weight: 600;
`;

export const AdditionalInfo = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.grayDark4};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
  button {
    height: 3rem;
  }
`;

export const BaseContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 0.5rem;
  height: 100%;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  h3 {
    margin: 0;

    font-family: 'Source Sans 3', sans-serif;
    font-weight: 600;
    line-height: 32px;
    letter-spacing: 0;
    color: ${({ theme }) => theme.colors.grayDark3};
    text-align: left;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  color: ${({ theme }) => theme.colors.blue6};
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const BpInfoContainer = styled.div`
  margin-top: 0.25rem;
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const BpName = styled.span`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: 0;
  color: ${({ theme }) => theme.colors.grayDark3};
  text-align: left;
`;

export const BpAddress = styled.span`
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0;
  color: ${({ theme }) => theme.colors.grayDark4};
  text-align: left;
`;

export const BpCnpj = styled.span`
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0;
  color: ${({ theme }) => theme.colors.grayDark4};
  text-align: left;
`;
